export default __webpack_public_path__ + "static/media/GCC_Playbook1@2x.10a264a4.jpg";